export const Styles = {
    statusMessage: {
        padding: '10px',
    },
};
